import React from 'react';
import { GiveawayBanner } from './giveaway-banner';
import { GiveawayWinners } from './giveaway-winners';
import { ProjectsList } from './projects-list';
import { TaskList } from './task-list';
import { LeaderboardWidget, Loader } from '@/components';
import { useTranslation } from 'react-i18next';
import { TaskCarousel } from './project-carousel';
import { MyProgress } from '@/views/home/MyProgress.svg';
import { connect } from 'react-redux';
import { RootState } from '@/store';
import { selectAuthStatus, selectUserProfile } from '@/store/features';
// import { useModal } from '@/hooks';
import {
  GiveawayHomepageDtoRead,
  useHomeControllerGetGuestHomeDataQuery,
  useHomeControllerGetUserHomeDataQuery,
} from '@/store/services/MidleNestApi.service';
import { Outlet } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface HomeViewProps {
  isAuthenticated?: boolean;
  userProfile?: any;
}

export function HomeView({ isAuthenticated = false, userProfile = null }: HomeViewProps) {
  const { t } = useTranslation();

  // const [isLoading, setIsLoading] = useState(false);
  // const [home, setHome] = useState<UserHomeDtaDto>();
  const { data: home, isLoading } = isAuthenticated
    ? useHomeControllerGetUserHomeDataQuery()
    : useHomeControllerGetGuestHomeDataQuery();

  if (home?.pendingTasks) {
    localStorage.removeItem('task-customer-waiting');
    localStorage.setItem('task-customer-waiting', home.pendingTasks.join(','));
  }

  // useEffect(() => {
  //
  //   (isAuthenticated ? getUserData : getGuestData)().then((res) => {
  //     setHome(res?.data);
  //     setIsLoading(false);
  //   });
  // }, [isAuthenticated]);

  // const { showModal } = useModal();

  return (
    <div className='relative max-w-7xl px-4 pt-12 mx-auto dashboard'>
      {/*
      isAuthenticated ? (
        <div className='absolute lg:right-44 md:right-36 -top-11 w-32 opacity-50 hidden md:block'>
          {// <MyProgress /> //}
        </div>
      ) : (
        <div
          className='z-10 absolute top-0 left-0 w-full h-full cursor-pointer'
          onClick={() => showModal('login')}
        />
      )
      */}
      {isLoading ? (
        <Loader />
      ) : (
        home && (
          <div className=' space-y-4 xl:space-y-6'>
            <div className='grid md:grid-cols-2 space-y-4 md:space-y-0 md:space-x-4 xl:space-x-6'>
              <GiveawayBanner
                {...(home?.leftGiveaway || ({} as GiveawayHomepageDtoRead))}
                isAuthenticated={isAuthenticated}
              />
              <GiveawayBanner
                {...(home?.rightGiveaway || ({} as GiveawayHomepageDtoRead))}
                isAuthenticated={isAuthenticated}
              />
            </div>

            <div className=''>
              <TaskCarousel campaigns={home.campaigns} />
            </div>

            <div className='space-y-4 lg:space-y-0 lg:space-x-4 xl:space-x-6 lg:grid lg:grid-cols-3 max-w-full overflow-hidden'>
              <TaskList title={t('Main Task')} loading={isLoading} tasks={home.mainTasks?.list} />
              <TaskList title={t('Hot')} tasks={home.leftTasks?.list} loading={isLoading} />
              <TaskList title={t('Max Points')} tasks={home.rightTasks?.list} loading={isLoading} />
            </div>
            <div className='flex'>
              <ProjectsList loading={isLoading} projects={home?.customers} />
            </div>
            <div className='space-y-4 lg:space-y-0 lg:flex lg:space-x-4 xl:space-x-6'>
              <LeaderboardWidget
                loading={isLoading}
                users={home.userLeaderboard.list}
                clans={home.guildLeaderboard.list}
                hideActions={true}
              />
              <LeaderboardWidget
                defaultTab='clans'
                loading={isLoading}
                users={home?.userLeaderboard.list}
                clans={home?.guildLeaderboard.list}
                hideActions={true}
              />
            </div>
            <div className='pb-4 xl:pb-6'>
              {
                <GiveawayWinners
                  leftReward={home?.leftLastGiveawayWithRewards}
                  rightReward={home?.rightLastGiveawayWithRewards}
                  userLeaderBoard={home?.prevUserLeaderboard}
                  guildLeaderBoard={home?.prevGuildLeaderboard}
                />
              }
            </div>
          </div>
        )
      )}
      <Outlet />
    </div>
  );
}

export default connect((state: RootState) => ({
  isAuthenticated: selectAuthStatus(state),
  userProfile: selectUserProfile(state),
}))(HomeView);
